module.exports = __webpack_public_path__ + "img/PRO QR-code.61ec081e.png";